import styled from '@emotion/styled'

import { breakpoints, container, palette, spacing } from 'main/ui'
import rose2GradientEnd from './GradientColor'

export const Container = styled.div`
  background-image: url(https://ucarecdn.com/8865f40e-23ee-4b3d-865c-8fe7e5e19188/BGheromobilelp2x.png),
    linear-gradient(233.65deg, ${palette.rose2} 1.89%, ${rose2GradientEnd} 100%);
  background-position: center bottom;
  background-size: cover;
`

/* ensure horizontal overflow of shadows within images doesn't extend beyond parent bounds,
so we don't get a horizontal scoll / white gap. while still allowing vertical overflow, so the
phones can layer into the next section */
export const Clip = styled.div`
  margin-bottom: -${spacing.majorScale(15)}px;
  overflow-x: hidden;
  padding: ${spacing.majorScale(8)}px ${spacing.majorScale(3)}px 0;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: ${container.maxWidth.sm}px;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
    position: relative; /* so bottom of device photos appears on top of subsequent content */
    margin: ${spacing.majorScale(12)}px auto 0;
    max-width: ${container.maxWidth.lg}px;
  }
`

export const ImageGroup = styled.div`
  align-items: flex-start;
  display: flex;
`

// images include shadows, but we want to position them ignoring the shadow
export const LeftImageContainer = styled.div`
  flex: 1 1 0;

  @media (min-width: ${breakpoints.lg}px) {
    width: 278px;
  }
`

export const RightImageContainer = styled(LeftImageContainer)`
  margin-left: -${spacing.majorScale(4)}px;
  margin-top: ${spacing.minorScale(3)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-left: -${spacing.majorScale(8)}px;
  }
`

// Use margin so that the block size is just the image of the phone (with shadow overflowing),
// so that it's easier to position correctly
export const Image = styled.img`
  width: 130.3%;
  margin-left: -14.95%;
  margin-top: -9.05%;
  /* no bottom margin so clip doesn't scroll vertically */
`

export const TextContent = styled.div`
  margin-bottom: ${spacing.majorScale(7)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-left: ${spacing.majorScale(6)}px;
    order: 2;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const ButtonContainer = styled.div`
  margin-top: ${spacing.majorScale(1)}px;

  &:first-child {
    margin-right: ${spacing.minorScale(1)}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    &:first-child {
      margin-right: ${spacing.majorScale(1)}px;
    }
  }
`
